import { render, staticRenderFns } from "./WeightClassRankings.vue?vue&type=template&id=6d1e45ef&scoped=true"
import script from "./WeightClassRankings.vue?vue&type=script&lang=js"
export * from "./WeightClassRankings.vue?vue&type=script&lang=js"
import style0 from "./WeightClassRankings.vue?vue&type=style&index=0&id=6d1e45ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1e45ef",
  null
  
)

export default component.exports